import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'

import FacebookIcon from '../../icons/FacebookCircle'
import {
  fetchCurrentUser,
  facebookLoginFulfilled,
  facebookLoginRejected,
  facebookLoginPending,
} from '../../../actions/authActions'
import { sendNotification } from '../../../actions/notificationActions'
import { LoginSocial } from '../styles'
import AuthToken from './AuthToken'

class FacebookLogin extends React.Component {
  handleSuccess = (e) => {
    e.preventDefault()
    const { dispatch, auth, onSuccess, onConfirmEmail } = this.props
    const { currentUser } = auth
    dispatch(facebookLoginFulfilled())
    if (currentUser.email && currentUser.sign_in_count > 1) {
      onSuccess()
    } else {
      onConfirmEmail()
    }
  }

  handleFailure = () => {
    const { dispatch } = this.props
    dispatch(sendNotification('Facebook login failed', 'error'))
    dispatch(facebookLoginRejected())
  }

  checkSignInStatus = () => {
    const { dispatch } = this.props

    dispatch(fetchCurrentUser()).then(() => {
      const { auth } = this.props
      if (auth.isSignedIn) {
        this.handleSuccess()
      } else {
        this.handleFailure()
      }
    })
  }

  handleFacebookResponse = () => {
    const { dispatch } = this.props

    dispatch(facebookLoginPending())
    axios
      .post('/omniauth/facebook/callback', null, {
        baseURL: '/',
        withCredentials: true,
        maxRedirects: 0,
      })
      .finally(this.checkSignInStatus)
  }

  handleClick = () => {
    window.FB.login(this.handleFacebookResponse, {
      scope: 'public_profile,email',
      fields: 'first_name,last_name,email',
    })
  }

  render() {
    const { children, serverSide, disabled } = this.props

    return (
      <form action="/omniauth/facebook" method="post">
        <AuthToken />
        <LoginSocial
          disabled={disabled}
          type="submit"
          onClick={serverSide ? null : this.handleClick}
          className="qa-facebook-login"
        >
          <FacebookIcon />
          {children}
        </LoginSocial>
      </form>
    )
  }
}

export default connect(({ auth }) => ({
  auth,
}))(FacebookLogin)
